/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rename_Key_FailedInputs */

const en_rename_key_failed = /** @type {(inputs: Rename_Key_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The key could not be changed. Try again.`)
};

const de_rename_key_failed = /** @type {(inputs: Rename_Key_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Schlüssel konnte nicht geändert werden. Versuche es erneut.`)
};

/**
* | output |
* | --- |
* | "The key could not be changed. Try again." |
*
* @param {Rename_Key_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rename_key_failed = /** @type {((inputs?: Rename_Key_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rename_Key_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_rename_key_failed(inputs)
	return en_rename_key_failed(inputs)
});